import Grid from '@mui/material/Grid2';

export default function GridSpacer({ size }) {
    if(!size) {
        size = 0;
    }
    
    return (
        <Grid size={size} />
    );
}